import { render, staticRenderFns } from "./Twofa.vue?vue&type=template&id=bbac1536"
import script from "./Twofa.vue?vue&type=script&lang=js"
export * from "./Twofa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports